import { Injectable } from '@angular/core';
import { Observable, Observer } from 'rxjs';
import { BaseurlService } from './baseurl.service';
import { map } from 'rxjs/operators';
import ReconnectingWebSocket from 'reconnecting-websocket';


@Injectable({
  providedIn: 'root'
})
export class WsService {

  constructor(
    private baseUrl: BaseurlService,
  ) {}

  public setUpWs<ToServer, FromServer>(relativeUrl: string): WsAbstraction<ToServer, FromServer> {
    const ws = new ReconnectingWebSocket(this.baseUrl.getWsBaseUrl() + relativeUrl);

    const observable = new Observable((obs: Observer<MessageEvent>) => {
      ws.onmessage = obs.next.bind(obs);
      return ws.close.bind(ws);
    });

    const observer: Pick<Observer<ToServer>, 'next'> = {
      next: (data: ToServer) => {
        if (ws.readyState === WebSocket.OPEN) {
          ws.send(JSON.stringify(data));
        }
      }
    };
    return new WsAbstraction(observable.pipe(map(v => (JSON.parse(v.data) as FromServer))), observer);
  }
}

export class WsAbstraction<ToServer, FromServer> {

  constructor(
    private observable: Observable<FromServer>,
    private observer: Pick<Observer<ToServer>, 'next'>,
  ) {
  }

  public read(): Observable<FromServer> {
    return this.observable;
  }

  public sendMessage(msg: ToServer) {
    this.observer.next(msg);
  }
}
